import { CREATE_USER_ROUTE_ID, USER_ROUTE_ID } from './common';
import UserList from './index';
import User from './User';

export default {
    [USER_ROUTE_ID]: () => <UserList />,
    [CREATE_USER_ROUTE_ID]: () => <User />,
};
